// extracted by mini-css-extract-plugin
export default {"container":"Wp-z","ratingLayout":"Xp-z","ratingLabel":"Yp-z","nonInteractiveRatingLabel":"Zp-z"};